/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Islocked1Inputs */

const en_entity_islocked1 = /** @type {(inputs: Entity_Islocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Locked`)
};

const de_entity_islocked1 = /** @type {(inputs: Entity_Islocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist gesperrt`)
};

/**
* | output |
* | --- |
* | "Is Locked" |
*
* @param {Entity_Islocked1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_islocked1 = /** @type {((inputs?: Entity_Islocked1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Islocked1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_islocked1(inputs)
	return de_entity_islocked1(inputs)
});
export { entity_islocked1 as "entity_isLocked" }